import { Box, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import TitleCase from "components/formatting/TitleCase";
import ISONumber from "components/formatting/ISONumber";

interface RadialSentimentTooltipProps {
  bar: {
    name: string;
    fill: string;
    payload: {
      value: number;
      percent: string;
    };
  }
}

export default function RadialSentimentTooltip(props: RadialSentimentTooltipProps): JSX.Element {
  const { i18n } = useTranslation();
  const { bar } = props;

  return (
    <Box>
      {/* Title */}
      <Typography sx={{mb: 1}} variant="h4">
        <Box
          sx={{
            width: 14,
            height: 14,
            backgroundColor: bar.fill,
            display:"inline-block",
            mr: 1,
            borderRadius: "3px"
          }} />
        <TitleCase text={bar.name}/>
      </Typography>

      {/* Count */}
      <Typography>
        {i18n.t("record-count")}:
        <Box sx={{display:"inline-block", ml: 1}}>
          <ISONumber number={bar.payload.value} sx={{ fontWeight: "bold" }}/>
        </Box>
      </Typography>

      {/* Percentage */}
      <Typography>
        {i18n.t("percent")}:
        <Box sx={{display:"inline-block", ml: 1, fontWeight: "bold" }}>
          {bar.payload.percent}%
        </Box>
      </Typography>
    </Box>
  );
}
